// @flow
import React, { Fragment, Component } from 'react';
import CryptoJS from 'crypto-js';
import type { Status } from 'types/Status';

import { FORM_CRYPTO_KEY, FORM_CRYPTO_IV } from 'constants/api';

import Breadcrumb from 'components/fragments/Breadcrumb';
import type { BlocContent } from 'types/NewsletterBloc';
import { getCentenaireHash } from 'utils/centenaireUtils';
import ContentBloc from 'components/newsletter/blocs/ContentBloc';
export type DispatchProps = {
    onSubmit: (values: Object) => void,
    fetchRematch: () => void,
};

export type StateProps = {
    rematchVote: {club: string, id: string, url: string, thumb: string},
    datarematch: Object,
};

type Props = {
  title: string,
  featured_media: {
    src: string,
    legend: string
  },
  meta_description: string,
  status: Status,
  description: BlocContent[],
  match: {
    params: {
      slug: string
    }
  },
  pageSlug: string
} & DispatchProps & StateProps;

type State = {
    videoPlay: Object
  };
class PageJeuConcours extends Component<Props, State> {
    state: State = {
        videoPlay: {}
    }
    componentDidMount() {
        this.props.fetchRematch();
    }
    onVote = (e: MouseEvent, video: Object) => {
        const { onSubmit } = this.props;
        e.preventDefault();

        const timestamp = getCentenaireHash();

        const data = [{
            'rematch_id': video.id,
            'rematch_meta_hash': timestamp,
        }];
        const iv = CryptoJS.enc.Hex.parse(FORM_CRYPTO_IV);
        const data_crypt =  CryptoJS.AES.encrypt(
            JSON.stringify(data), 
            CryptoJS.enc.Hex.parse(FORM_CRYPTO_KEY), {
                iv,
                padding: CryptoJS.pad.ZeroPadding,
        }).toString();

        const data_final = {
            'data': data_crypt,
            'video': video
        };
        onSubmit(data_final);
    }

    onClickVideo = (e: MouseEvent, videoPlay: Object) => {
        this.setState({videoPlay});
    }
    renderDetail = () => {
        const { description } = this.props;
        return description.map<any>((blocFigure, index) => {
          return <ContentBloc key={index} {...blocFigure} />;
        });
      };
  render() {
    const {
      featured_media,
      title,
      meta_description,
      rematchVote,
      //datarematch
    } = this.props;

    const { videoPlay } = this.state;

    const videos = [
        {
            id: '1_Stade_Blayais',
            club: 'Stade Blayais',
            url: 'https://www.youtube.com/embed/5ev4dZoxCFc',
            thumb: 'https://img.youtube.com/vi/5ev4dZoxCFc/0.jpg',
        }, {
            id: '2_Saint_Medard_en_Jalles',
            club: 'Saint Médard en Jalles',
            url: 'https://www.youtube.com/embed/oscgeFFAXr0',
            thumb: 'https://img.youtube.com/vi/oscgeFFAXr0/0.jpg',
        }, {
            id: '3_RC_Garches_Vaucresson',
            club: 'RC Garches Vaucresson',
            url: 'https://www.youtube.com/embed/gd_sH69G5TQ',
            thumb: 'https://img.youtube.com/vi/gd_sH69G5TQ/0.jpg',
        }, {
            id: '4_AS_Layracaise',
            club: 'AS Layracaise',
            url: 'https://www.youtube.com/embed/2YBk-L7dDd4',
            thumb: 'https://img.youtube.com/vi/2YBk-L7dDd4/0.jpg',
        }, {
            id: '5_Racing_Club_Queyrannais',
            club: 'Racing Club Queyrannais',
            url: 'https://www.youtube.com/embed/3hXHJudYFXg',
            thumb: 'https://img.youtube.com/vi/3hXHJudYFXg/0.jpg',
        }, {
            id: '6_RC_Bon_Encontre_Boe',
            club: 'RC Bon Encontre Boé',
            url: 'https://www.youtube.com/embed/9fTg9Rm2AZg',
            thumb: 'https://img.youtube.com/vi/9fTg9Rm2AZg/0.jpg',
        }, {
            id: '7_AS_Fleurantine',
            club: 'AS Fleurantine',
            url: 'https://www.youtube.com/embed/A_3bKAcjFgs',
            thumb: 'https://img.youtube.com/vi/A_3bKAcjFgs/0.jpg',
        }, {
            id: '8_AS_Merignac',
            club: 'AS Mérignac',
            url: 'https://www.youtube.com/embed/4uRPqLkx6ek',
            thumb: 'https://img.youtube.com/vi/4uRPqLkx6ek/0.jpg',
        }, {
            id: '9_Avenir_Valencien_Rugby',
            club: 'Avenir Valencien Rugby',
            url: 'https://www.youtube.com/embed/V2J7Oo_ZTyA',
            thumb: 'https://img.youtube.com/vi/V2J7Oo_ZTyA/0.jpg',
        }, {
            id: '10_Stade_Langonnais',
            club: 'Stade Langonnais',
            url: 'https://www.youtube.com/embed/bqX7U5vzlLc',
            thumb: 'https://img.youtube.com/vi/bqX7U5vzlLc/0.jpg',
        }, {
            id: '11_Terres_de_France_Rugby',
            club: 'Terres de France Rugby',
            url: 'https://www.youtube.com/embed/MGBcP3rQCq0',
            thumb: 'https://img.youtube.com/vi/MGBcP3rQCq0/0.jpg',
        }, {
            id: '12_AS_Martignas',
            club: 'AS Martignas',
            url: 'https://www.youtube.com/embed/qp-uKC-rzFo',
            thumb: 'https://img.youtube.com/vi/qp-uKC-rzFo/0.jpg',
        }, {
            id: '13_RC_Auch',
            club: 'RC Auch',
            url: 'https://www.youtube.com/embed/pfnM6CxwexU',
            thumb: 'https://img.youtube.com/vi/pfnM6CxwexU/0.jpg',
        }, {
            id: '14_US_Cambo',
            club: 'US Cambo',
            url: 'https://www.youtube.com/embed/-B3FiQ4CEbQ',
            thumb: 'https://img.youtube.com/vi/-B3FiQ4CEbQ/0.jpg',
        }, {
            id: '15_US_Mugron',
            club: 'US Mugron',
            url: 'https://www.youtube.com/embed/fSSK4LSjEvg',
            thumb: 'https://img.youtube.com/vi/fSSK4LSjEvg/0.jpg',
        }, {
            id: '16_Castelmoron_XV',
            club: 'Castelmoron XV',
            url: 'https://www.youtube.com/embed/V78wZIfzYb8',
            thumb: 'https://img.youtube.com/vi/V78wZIfzYb8/0.jpg',
        }, {
            id: '17_RC_Villenavais',
            club: 'RC Villenavais',
            url: 'https://www.youtube.com/embed/6JIOIW6Zncw',
            thumb: 'https://img.youtube.com/vi/6JIOIW6Zncw/0.jpg',
        }, {
            id: '18_SC_Mazamet',
            club: 'SC Mazamet',
            url: 'https://www.youtube.com/embed/Imn5oJfp_cg',
            thumb: 'https://img.youtube.com/vi/Imn5oJfp_cg/0.jpg',
        }, {
            id: '19_La_Brede_Rugby_XV',
            club: 'La Brede Rugby XV',
            url: 'https://www.youtube.com/embed/AruBBuHmjQU',
            thumb: 'https://img.youtube.com/vi/AruBBuHmjQU/0.jpg',
        }, {
            id: '20_Rugby_Carbonne_Longages',
            club: 'Rugby Carbonne Longages',
            url: 'https://www.youtube.com/embed/1wc0mz5-zks',
            thumb: 'https://img.youtube.com/vi/1wc0mz5-zks/0.jpg',
        }, {
            id: '21_US_Vendome_Rugby',
            club: 'US Vendôme Rugby',
            url: 'https://www.youtube.com/embed/fFFz9cThU7c',
            thumb: 'https://img.youtube.com/vi/fFFz9cThU7c/0.jpg',
        }
    ];

    return (
      <Fragment>
        <section className="banner banner--center">
          <div className="banner__thumbnail img-blue-dark" style={{ backgroundImage: `url(${featured_media.src})` }} />
          <div className="container">
            <Breadcrumb elements={[{ name: 'accueil', to: '/' }, title]} isDark />
            <h1 className="ft-h2">{title}</h1>
            {meta_description &&
            <p className="banner__desc">
              {meta_description}
            </p>}
          </div>
        </section>
        <section className="section section-white container">
            <div className="page">
                {this.renderDetail()}
            </div>
            <div className="row">
            {videos.map((video)=> {
                return (
                <div key={video.url} className="col col-md-6 col-lg-3 mt-2" style={{textAlign: "center"}}>
                    {videoPlay && videoPlay.url && videoPlay.url === video.url &&
                        <iframe 
                            style={{
                                height: "300px",
                                verticalAlign:"bottom",
                                display:"block",
                                marginRight:"auto",
                                marginLeft:"auto"
                            }} 
                            src={`${video.url}?autoplay=1`} 
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                            allowFullScreen={true} 
                            frameBorder="0"
                            title={video.club}>
                        </iframe>
                    } 
                    {(!videoPlay || !videoPlay.url || videoPlay.url !== video.url) &&
                    <div 
                        className="box card card--video" 
                        style={{height: "300px"}} 
                        onClick={(e) => this.onClickVideo(e, video)}
                        role="button"
                        tabIndex={0}>
                        <div 
                            className="card__thumbnail img-blue-dark"
                            style={{
                                height: "300px",
                                cursor:"pointer",
                                verticalAlign:"baseline",
                                backgroundImage: "url("+video.thumb+")"
                            }}
                        >
                        </div>
                        <div className="card__footer">
                            <span className="link-icon link-icon--medium is-dark">
                                <i className="icon icon-play"></i>
                            </span>
                            <h5 
                                className="card__title ft-truncat"
                                style={{textAlign: "left"}}>
                                {video.club}
                            </h5>
                            <p className="card__date"></p>
                        </div>
                        { rematchVote && rematchVote.id === video.id &&  
                        <div className="card__type"><span className="label label--red">Votre vote</span></div>}
                        {/**datarematch && datarematch[video.id] &&
                        <div className="card__type" style={{left:'auto', right: '16px'}}><span className="label label--yellow">{ datarematch[video.id] > 1 ?  datarematch[video.id]+' votes' : '1 vote'}</span></div>
                        */}
                        {/** datarematch && !datarematch[video.id] &&
                        <div className="card__type" style={{left:'auto', right: '16px'}}><span className="label label--yellow">{'0 vote'}</span></div>
                        */}
                    </div>
                    }
                    {/** (!rematchVote || !rematchVote.club) &&  
                    <button className="btn btn--primary mt-2" onClick={(e) => this.onVote(e, video)} aria-label="Voter">
                        Voter pour cet essai
                    </button>
                    */}
                </div>
                );
            })}
          </div>
        </section>
      </Fragment>
    );
  }
}

export default PageJeuConcours;
